import React, { useEffect, useRef } from 'react';
import './reglspopup.css';
import { useTranslation } from 'react-i18next';

const ReglasPopup = ({ isOpen, onClose }) => {

  const dialogRef = useRef(null);

  const [t] = useTranslation("detail_blog");

  useEffect(() => {
    if (!dialogRef.current) return;

    if (isOpen) {
        dialogRef.current.showModal();
    } else if (dialogRef.current.open) {
        dialogRef.current.close();
    }
}, [isOpen]);

  return (
    <dialog
      ref={dialogRef}
      className="write-me-modal"
      onClose={onClose}
    >

      <section className="reflexion-text-modal__panel">

        {/* CERRAR */}
        <button
          type="button"
          aria-label="Cerrar contenido"
          className="reflexion-text-modal__close"
          onClick={() => {
            dialogRef.current?.close();
            onClose();
          }}
        >
          ×
        </button>

        <div className="reflexion-text-modal__copy">

          {/* HEADER */}
          <header className="reflexion-text-modal__header">

            <h2
              id="reflexion-text-modal-title"
              className="reflexion-text-modal__title"
            >
              {t('reglas.rule1')}
            </h2>

          </header>

          {/* BODY */}
          <div className="reflexion-text-modal__body">

            <p>
              {t('reglas.rule2')}
            </p>

            <p>
              {t('reglas.rule3')}
            </p>

            <p>
              <strong>
                {t('reglas.rule4')}
              </strong>
            </p>

            <p>• {t('reglas.rule5')}</p>
            <p className='menos-esp'>• {t('reglas.rule6')}</p>
            <p className='menos-esp'>• {t('reglas.rule7')}</p>
            <p className='menos-esp'>• {t('reglas.rule8')}</p>

            <p>
              <strong>
                {t('reglas.rule9')}
              </strong>
            </p>

            <p>• {t('reglas.rule10')}</p>
            <p className='menos-esp'>• {t('reglas.rule11')}</p>
            <p className='menos-esp'>• {t('reglas.rule12')}</p>
            <p className='menos-esp'>• {t('reglas.rule13')}</p>
            <p className='menos-esp'>• {t('reglas.rule14')}</p>
            <p className='menos-esp'>• {t('reglas.rule15')}</p>
            <p className='menos-esp'>• {t('reglas.rule16')}</p>
            <p className='menos-esp'>• {t('reglas.rule17')}</p>
            <p className='menos-esp'>• {t('reglas.rule18')}</p>

            <p>{t('reglas.rule19')}</p>
            <p>{t('reglas.rule20')}</p>

            <p>
              {t('reglas.rule21')}{' '}

              <a
                href="mailto:comentarios.ricardosalinas@gruposalinas.com.mx"
                target="_blank"
                rel="noopener noreferrer"
              >
                comentarios.ricardosalinas@gruposalinas.com.mx
              </a>
            </p>

          </div>
        </div>

      </section>

    </dialog>
  );
};

export default ReglasPopup;